module.exports = __webpack_public_path__ + "static/images/components/ButtonTiny/images/default-tile.53bd7f2b.png";


//////////////////
// WEBPACK FOOTER
// ./components/ButtonTiny/images/default-tile.png
// module id = 2578
// module chunks = 11